const getters = {
  getProdutosSelecionados: (state) => state.produtosSelecionados,
  getPautaSelecionada: (state) => state.pautaSelecionada,
  getProdutosReferenciacao: (state) => state.produtosReferenciacao,
};

export default getters;
